import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import { getId, usePermissions } from "../../user/User"
import { toast } from "react-toastify"
import { useEffect } from "react"
import { useSector } from "../../sector/Sector"
import SectorDetailView from './SectorDetailView'

const SectorEdit = () => {
    const navigate = useNavigate()

    let { id } = useParams()
    let {
        name, setName,
    } = useSector(id)

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.sector !== undefined && !permissions.sector) {
            toast.error("You don't have permission to edit sectors!")
            navigate("/")
        }
    }, [permissions])

    return <SectorDetailView id={id}
        name={name} setName={setName}
    />
}

export default SectorEdit